import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Logistics from '../../template/Logistics/Logistics';
import Load from '../../template/Load/Load';
import WebViewHeader from '../../template/WebViewHeader/WebViewHeader';
// import { COURSE_URL } from "../../constants";
import { parseQuery } from '../../utils/tools';
import AXIOS from '../../api/axios';
import Nothing from '../../template/Nothing/Nothing';
import UA from '../../utils/ua';

const queryObj = parseQuery(window.location.search.slice(1));

class LogisticsPage extends Component {
    constructor(props){
        super(props);
        this.isMobile = UA.mobileClient;
        this.state = {
            // logisticsInfo: []
        };
    }
    componentDidMount(){
        AXIOS.getLogistics({data:{userId:queryObj.stuid}},(res, err) => {
            if(err) alert(err.errorMessage);
            else{
                this.setState({
                    completeRander: true,
                    logisticsInfo: res
                    // logisticsInfo: [
                    //     {
                    //         waybillNo:123456,
                    //         status: 0,
                    //         goodsName: '实验器材',
                    //         consignee: '王二狗',
                    //         consigneePhone: '13546875645',
                    //         province: '浙江省',
                    //         city: '杭州市',
                    //         area: '拱墅区',
                    //         addressDetail: '丰潭路508号7号楼11F'
                    //     },
                    //     {
                    //         waybillNo:123456,
                    //         status: 0,
                    //         goodsName: '实验器材',
                    //         consignee: '王二狗',
                    //         consigneePhone: '13546875645',
                    //         province: '浙江省',
                    //         city: '杭州市',
                    //         area: '拱墅区',
                    //         addressDetail: '丰潭路508号7号楼11F'
                    //     }
                    // ]
                })
            }
        })
    }
    render(){
        const { logisticsInfo, completeRander } = this.state;
        return(
            <DocumentTitle title={'物流详情'}>
                <React.Fragment>
                    {!completeRander &&
                        <Load />
                    }
                    {!this.isMobile &&
                        <WebViewHeader showBack={false} showClose={false} title={'物流详情'} />
                    }
                    {!!(completeRander && logisticsInfo.length) &&
                        <Logistics logisticsInfo={logisticsInfo} />
                    }
                    {!!(completeRander && !logisticsInfo.length) &&
                        <Nothing />
                    }
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default LogisticsPage;



// WEBPACK FOOTER //
// ./src/components/experimentOrderPage/LogisticsPage.jsx